export default "__VITE_ASSET__WZ94Mg2___"